require('ui-cropper');
require('./kovImageEditor.scss');

let m = angular.module( 'kovImageEditorComponentModule', ['uiCropper'] );
m.component( 'kovImageEditor', require( './kovImageEditor.js' ) );

module.exports = 'kovImageEditorComponentModule';